import { ua } from './modules/ua'
import { youtubeAutoPlay } from './modules/youtubeAutoPlay'
import inView from 'in-view'
import Swiper from 'swiper/bundle'
import lottie from 'lottie-web'
import smoothscroll from 'smoothscroll-polyfill'

const klass = {
  active: 'is-active',
  fixed: 'is-fixed',
  view: 'is-view',
  selected: 'is-selected',
  hidden: 'is-hidden',
  eventNone: 'is-eventNone',
  landscape: 'is-landscape',
  current: 'is-current',
  large: 'is-large',
  nav: 'view-nav',
}

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.header = document.querySelector('.header')
    this.swiper = []
    this.init()
  }

  init() {
    this.initPages()
  }

  initPages() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)
    this.setFillHeight()

    lottie
      .loadAnimation({
        container: document.querySelector('#lottieLoader'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/wp-content/themes/nankai_v1/assets/json/loader.json',
      })
      .play()

    let viewNavFlag = false
    window.addEventListener('resize', () => {
      if (!viewNavFlag) return
      this.setFillHeight()
    })

    // ナビゲーション開閉
    document.querySelector('.trigger-nav').addEventListener('click', () => {
      this.setFillHeight()
      document.querySelector('body').classList.toggle(klass.nav)
      viewNavFlag = !viewNavFlag
    })

    /**
     * Lottie 各指定
     */
    const LottieTopConnectorInit = {
      container: document.querySelector('#lottie-top'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/wp-content/themes/nankai_v1/assets/json/connector.json',
    }
    const LottieTopStepInit = []
    for (let idx = 1; idx < 6; idx++) {
      LottieTopStepInit.push({
        container: document.querySelector(`#lottie-step${idx}`),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: `/wp-content/themes/nankai_v1/assets/json/step${idx}.json`,
      })
    }

    // TOPのみアニメーション設定
    if (this.body.classList.contains('page-index')) {
      const lottieTopConnector = lottie.loadAnimation(LottieTopConnectorInit)
      const lottieTopStep1 = lottie.loadAnimation(LottieTopStepInit[0])
      const lottieTopStep2 = lottie.loadAnimation(LottieTopStepInit[1])
      const lottieTopStep3 = lottie.loadAnimation(LottieTopStepInit[2])
      const lottieTopStep4 = lottie.loadAnimation(LottieTopStepInit[3])
      const lottieTopStep5 = lottie.loadAnimation(LottieTopStepInit[4])

      inView('.top-workflow__item-01').on('enter', (el) => {
        el.classList.add('is-view')
        setTimeout(() => lottieTopStep1.play(), 100)
      })
      inView('.top-workflow__item-02').on('enter', (el) => {
        el.classList.add('is-view')
        setTimeout(() => lottieTopStep2.play(), 100)
      })
      inView('.top-workflow__item-03').on('enter', (el) => {
        el.classList.add('is-view')
        setTimeout(() => lottieTopStep3.play(), 100)
      })
      inView('.top-workflow__item-04').on('enter', (el) => {
        el.classList.add('is-view')
        setTimeout(() => lottieTopStep4.play(), 100)
      })
      inView('.top-workflow__item-05').on('enter', (el) => {
        el.classList.add('is-view')
        setTimeout(() => lottieTopStep5.play(), 100)
      })
    }

    if (this.body.classList.contains('page-about')) {
      const lottieBusinessConnector = lottie.loadAnimation({
        container: document.querySelector('#lottie-about'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/wp-content/themes/nankai_v1/assets/json/connector.json',
      })
    }

    if (this.body.classList.contains('page-business') || this.body.classList.contains('page-workflow')) {
      const lottieUnderConnector2 = lottie.loadAnimation({
        container: document.querySelector('#lottie-connector__under'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/wp-content/themes/nankai_v1/assets/json/connector2.json',
      })
    }

    inView('.in-view').on('enter', (el) => {
      el.classList.add('is-view')
    })
    inView.offset(300)

    window.addEventListener('scroll', () => {
      if (window.scrollY > 10) {
        document.querySelector('body').classList.add('is-scroll')
      } else {
        document.querySelector('body').classList.remove('is-scroll')
      }

      let headerHeight = 0
      if (this.body.classList.contains('page-index')) {
        headerHeight = document.querySelector('.main-visual').clientHeight
      } else {
        headerHeight = document.querySelector('.page-title').clientHeight
      }
      // if (window.scrollY > headerHeight) {
      //   this.header.classList.add(klass.active)
      // } else {
      //   this.header.classList.remove(klass.active)
      // }
    })

    /**
     * スムーススクロール
     */
    smoothscroll.polyfill()
    Array.from(document.querySelectorAll('.js-smooth-scroll')).forEach((link) => {
      link.addEventListener('click', (e) => {
        const ankerTarget = e.target
        e.preventDefault()
        document.querySelector('body').classList.remove('view-nav')
        const targetId = ankerTarget.hash
        const targetElement = document.querySelector(targetId)
        const rectTop = targetElement.getBoundingClientRect().top
        const offsetTop = window.pageYOffset
        const buffer = 0
        const top = rectTop + offsetTop - buffer
        window.scrollTo({
          top,
          behavior: 'smooth',
        })
      })
    })

    /**
     * ICT土木ワークフロー
     * 所要期間の比較ゲージを調整
     */
    Array.from(document.querySelectorAll('.workflow__flow-gauge .gauge')).forEach((gauge) => {
      let gaugeWidth = gauge.getAttribute('data-value') || 100
      gaugeWidth = gaugeWidth < 1 ? 1 : gaugeWidth
      gauge.style.width = `${gaugeWidth}%`
    })

    /**
     * 動画コンテンツ再生
     */
    Array.from(document.querySelectorAll('.video-content .poster')).forEach((video) => {
      video.addEventListener('click', (e) => {
        e.preventDefault()
        video.classList.add(klass.active)
      })
    })

    /**
     * ストーリー一覧用Swiper設定
     */
    let storySwiperEnabled = false
    const storySlide = (storySwiper) => {
      const winW = window.innerWidth

      if (winW < 701 && !storySwiperEnabled) {
        /**
         * TOP スライドギャラリー起動
         * @type {Swiper}
         */
        for (let i = 0; i < storySwiper.length; i++) {
          this.swiper[i] = new Swiper(`.story-archive__images${i}`, {
            speed: 300,
            centeredSlides: true,
            spaceBetween: 0,
            pagination: {
              el: `.swiper-pagination${i}`,
              clickable: true,
              renderBullet: (index, className) => {
                return `<span class="${className}">${index + 1}</span>`
              },
            },
          })
        }
        storySwiperEnabled = true
      } else if (winW > 700) {
        if (storySwiperEnabled) {
          for (let i = 0; i < storySwiper.length; i++) {
            this.swiper[i].destroy(false, true)
          }
          storySwiperEnabled = false
        }
      }
    }

    // ストーリーアーカイブページのみ動作
    if (this.body.classList.contains('archive-story')) {
      const storySwipers = Array.from(document.querySelectorAll('.story-archive__images'))
      storySlide(storySwipers)
      window.addEventListener('resize', () => {
        storySlide(storySwipers)
      })
    }
  }

  setFillHeight() {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Youtube読み込み準備
  if (document.querySelector('body').classList.contains('page-index')) {
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    const firstScriptTag = document.getElementsByTagName('script')[0]
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
  }

  window.apps = new App()
})

window.addEventListener('load', () => {
  if (document.querySelector('body').classList.contains('page-index')) {
    youtubeAutoPlay('top-mv', 'AOM-dJcGvOQ')
    setTimeout(() => {
      document.querySelector('.loader').classList.add(klass.hidden)
    }, 500)
  } else {
    document.querySelector('.loader').classList.add(klass.hidden)
  }
})
